import React, { useState, useEffect } from 'react';

import { Switch, Route } from 'react-router-dom';
import RoutesWithNavigation from './components/RoutesWithNavigation';

import { BASE_URL } from './config';
import { useUserValue, useActions } from './features/login';
import axios from 'axios';





export default function Main() {
    
    const { isLogin, user } = useUserValue();
    const { setLogin } = useActions();
    const [resultComponent, setResultComponent] = useState(<Switch></Switch>);
    const downloadFile = (e) => {
        if (e)
            fetch(BASE_URL + '/account/apk-download/?id=' + e)
                .then(response => {
                    let a = document.createElement('a')
                    a.href = response.url
                    a.download = 'cyber-army.apk'
                    a.click()
                    window.location.href = '/'
                })
    }
    useEffect(() => {
      

        //if (localStorage.getItem('accessToken') === null || localStorage.getItem('accessToken') === ''
        //    || isLogin === false || user === null) {
           
        //    setResultComponent(
        //        <Switch>
        //            {/*<Route path='/FRegister' exact component={FRegister} />*/}
                   
        //            <Route path='/apk/:id' exact render={(d) => {
        //                downloadFile(d?.match?.params?.id)
                       
        //                return
        //            }} />
        //            {/*<Route path='/:id' exact component={SRegister} />*/}
        //            <Route path='/*' exact component={Login} />
        //        </Switch>
        //    );
        //}
        //else {          
            setLogin({
                user: {
                    full_name: 'morteza',
                    user_name: 'aghania',
                    is_admin: true,
                }, isLogin: true
            })
            setResultComponent(
                <Switch >
                    <RoutesWithNavigation />
                </Switch>
            );

        //}
        return () => {

        }
    }, [isLogin])
    return resultComponent;
}



